import { render, staticRenderFns } from "./editDocFileImage.vue?vue&type=template&id=39c69a73&scoped=true&"
import script from "./editDocFileImage.vue?vue&type=script&lang=js&"
export * from "./editDocFileImage.vue?vue&type=script&lang=js&"
import style0 from "./editDocFileImage.vue?vue&type=style&index=0&id=39c69a73&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c69a73",
  null
  
)

export default component.exports